import axios from 'axios';

const runtimeApiUrl = (typeof window !== 'undefined' && window._env_ && window._env_.REACT_APP_API_URL)
  ? window._env_.REACT_APP_API_URL
  : process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: runtimeApiUrl,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;